import { callApi } from "../callApi"

export const getInvitationDeclineToken = (token: string) =>
  callApi<null, null>({
    method: "GET",
    path: `/invitation/decline?token=${token}`,
  })
